export default __webpack_public_path__ + "../staticImages/LABEL_AI_black_transparent.svg";